/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class PlotApi extends runtime.BaseAPI {
    /**
     * Create Plot
     */
    async v2CreatePlotRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2CreatePlot().');
        }
        if (requestParameters['genericPlotCreate'] == null) {
            throw new runtime.RequiredError('genericPlotCreate', 'Required parameter "genericPlotCreate" was null or undefined when calling v2CreatePlot().');
        }
        const queryParameters = {};
        if (requestParameters['tabId'] != null) {
            queryParameters['tab_id'] = requestParameters['tabId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/plot/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['genericPlotCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Plot
     */
    async v2CreatePlot(requestParameters, initOverrides) {
        const response = await this.v2CreatePlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Profile Tab Delete Plot
     */
    async v2DeletePlotRaw(requestParameters, initOverrides) {
        if (requestParameters['plotId'] == null) {
            throw new runtime.RequiredError('plotId', 'Required parameter "plotId" was null or undefined when calling v2DeletePlot().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/plot/{plot_id}`;
        urlPath = urlPath.replace(`{${"plot_id"}}`, encodeURIComponent(String(requestParameters['plotId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Profile Tab Delete Plot
     */
    async v2DeletePlot(requestParameters, initOverrides) {
        const response = await this.v2DeletePlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Plot
     */
    async v2GetPlotRaw(requestParameters, initOverrides) {
        if (requestParameters['plotId'] == null) {
            throw new runtime.RequiredError('plotId', 'Required parameter "plotId" was null or undefined when calling v2GetPlot().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/plot/{plot_id}`;
        urlPath = urlPath.replace(`{${"plot_id"}}`, encodeURIComponent(String(requestParameters['plotId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Plot
     */
    async v2GetPlot(requestParameters, initOverrides) {
        const response = await this.v2GetPlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Tab Plots
     */
    async v2GetTabPlotsRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2GetTabPlots().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/plot/tab/{tab_id}`;
        urlPath = urlPath.replace(`{${"tab_id"}}`, encodeURIComponent(String(requestParameters['tabId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Tab Plots
     */
    async v2GetTabPlots(requestParameters, initOverrides) {
        const response = await this.v2GetTabPlotsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update Plot
     */
    async v2UpdatePlotRaw(requestParameters, initOverrides) {
        if (requestParameters['plotId'] == null) {
            throw new runtime.RequiredError('plotId', 'Required parameter "plotId" was null or undefined when calling v2UpdatePlot().');
        }
        if (requestParameters['genericPlotUpdate'] == null) {
            throw new runtime.RequiredError('genericPlotUpdate', 'Required parameter "genericPlotUpdate" was null or undefined when calling v2UpdatePlot().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/plot/{plot_id}`;
        urlPath = urlPath.replace(`{${"plot_id"}}`, encodeURIComponent(String(requestParameters['plotId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['genericPlotUpdate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update Plot
     */
    async v2UpdatePlot(requestParameters, initOverrides) {
        const response = await this.v2UpdatePlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
